import { InjectionToken } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export const UPDATE_USER = new InjectionToken<BehaviorSubject<void>>('UPDATE_USER');

